import React from 'react';
import { FadeIn } from '../components/FadeIn';
import { SectionLabel } from '../components/SectionLabel';
export function CreatorSection() {
  return <section className="py-14 md:py-20 px-6 bg-midnight-light" data-id="element-147">
      <div className="max-w-6xl mx-auto" data-id="element-148">
        <FadeIn className="text-center mb-16" data-id="element-149">
          <SectionLabel text="The Woman Behind The Method" data-id="element-150" />
        </FadeIn>

        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20" data-id="element-151">
          {/* Image Side */}
          <FadeIn direction="right" className="w-full md:w-1/2" data-id="element-152">
            <div className="relative aspect-[4/5] max-w-md mx-auto rounded-2xl overflow-hidden border border-rosegold/20 shadow-2xl" data-id="element-153">
              <div className="absolute inset-0 bg-gradient-to-t from-midnight via-transparent to-transparent z-10" data-id="element-154" />
              <div className="absolute inset-0 shadow-[inset_0_0_60px_rgba(13,27,42,0.8)] z-20 pointer-events-none" data-id="element-155" />
              <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=800&q=80" alt="Creator" className="w-full h-full object-cover object-center" data-id="element-156" />
            </div>
          </FadeIn>

          {/* Bio Side */}
          <FadeIn direction="left" className="w-full md:w-1/2" data-id="element-157">
            <h2 className="font-playfair text-3xl md:text-5xl font-bold text-warmwhite mb-2" data-id="element-158">
              Elena Rostova
            </h2>
            <p className="font-inter text-rosegold text-lg mb-8 font-medium" data-id="element-159">
              Nervous System Educator & Breathwork Specialist
            </p>

            <div className="font-inter text-softgray space-y-5 text-base md:text-lg leading-relaxed mb-10" data-id="element-160">
              <p data-id="element-161">
                Elena spent 11 years searching for a way to control the rage
                that was quietly destroying her relationships — and her sense of
                self.
              </p>
              <p data-id="element-162">
                A single mother, a professional, and someone who had tried every
                meditation app, therapy session, and breathing exercise the
                wellness industry had to offer.
              </p>
              <p className="font-medium text-warmwhite" data-id="element-163">
                Nothing worked fast enough.
              </p>
              <p data-id="element-164">
                Until she discovered that anger isn't an emotion you manage —
                it's a physiological state you interrupt.
              </p>
              <p data-id="element-165">
                After studying vagus nerve activation and breathwork science,
                she developed The Oxygen Pulse Sequence — a 55-second protocol
                that she now teaches to women across the United States.
              </p>
              <p data-id="element-166">
                The Anger Circuit Breaker is the distillation of everything she
                learned — packaged into something you can use right now, in your
                car, in your kitchen, or in the middle of an argument.
              </p>
            </div>

            {/* Credentials */}
            <div className="flex flex-wrap gap-3" data-id="element-167">
              <span className="inline-flex items-center px-4 py-2 rounded-full border border-rosegold/30 bg-midnight text-xs md:text-sm text-warmwhite font-inter" data-id="element-168">
                🎓 Certified Breathwork Practitioner
              </span>
              <span className="inline-flex items-center px-4 py-2 rounded-full border border-rosegold/30 bg-midnight text-xs md:text-sm text-warmwhite font-inter" data-id="element-169">
                🧠 Nervous System Educator
              </span>
              <span className="inline-flex items-center px-4 py-2 rounded-full border border-rosegold/30 bg-midnight text-xs md:text-sm text-warmwhite font-inter" data-id="element-170">
                ❤️ 2,000+ Women Helped
              </span>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}